module.exports = __webpack_public_path__ + "static/emma-3097cbdb58b6294ad79782efebcf0bd0.jpg";